import createClass from 'create-react-class';
import React from 'react';

import { ETicketMobileList } from '../etickets';


export const ETicketMobilePanel = createClass({
    displayName: "ETicketMobilePanel",

    render(){
        return (
            <div>
                <ETicketMobileList eticketDisplays={this.props.EticketsDisplay}></ETicketMobileList>
            </div>
        );
    }
});
